<template>
  <div>
    <div class="row">
      <div class="col-6" v-if="material">
        <div class="">
          <h3>物料信息</h3>
          <div>
            <div class="d-inline-block">
              <button class='btn btn-primary' @click="updateMaterial">更新</button>
            </div>

            <div class="float-right">
              <button class='btn btn-danger' @click="deleteMaterial">删除</button>
            </div>
            <form>
              <div class="form-group row">
                <label for="material-name" class="col-2 col-form-label">物料名</label>
                <div class="col-4">
                  <input class="form-control" type="text" id="material-name" v-model="material.material_name">
                </div>
                <label for="material-id" class="col-2 col-form-label">物料ID</label>
                <div class="col-4">
                  <input class="form-control" type="text" id="material-id" :value="material.mid" readonly>
                </div>
              </div>

              <div class="form-group row">
                <label for="material-amount" class="col-2 col-form-label">库存</label>
                <div class="col-4">
                  <input class="form-control" type="text" id="material-amount" v-model="material.amount">
                </div>
                <label for="material-unit" class="col-2 col-form-label">单位</label>
                <div class="col-4">
                  <input class="form-control" type="text" id="material-unit" v-model="material.unit">
                </div>
              </div>

              <div class="form-group row">
                <label for="material-charge-on" class="col-2 col-form-label">扣除方式</label>
                <div class="col-4">
                  <select class="form-control" id="material-charge-on" v-model="material.charge_on">
                    <option v-for="(display, status) in chargeOnList" :value="status">{{display}}</option>
                  </select>
                </div>
                <label for="material-charge-amount" class="col-2 col-form-label">每次扣除数量</label>
                <div class="col-4">
                  <input class="form-control" type="text" id="material-unit" v-model="material.charge_amount">
                </div>
              </div>

            </form>
          </div>  
        </div>
          
        <div class=" my-5">
          <h3>绑定产品</h3>
          <div class="d-inline-block">
              <button class='btn btn-primary' @click="addMaterialOn">添加</button>
            </div>
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th></th>
                <th>产品代码</th>
                <th>产品名</th>
                <th>创建时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(product, index) in material.ons">
                <td>{{index + 1}}</td>
                <td>
                  <router-link :to='"/orders?product_code=" + product.product_code'>{{product.product_code}}</router-link>
                </td>
                <td>{{product.product_name}}</td>
                <td>
                  <local-time :time="product.created_at"></local-time>
                </td>
                <td>
                  <button class="btn btn-sm btn-danger" @click="deleteMaterialOn(product.product_code)">删除</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      <div class="col-6" v-if="logs">
        <h3>操作记录</h3>
        <pager v-bind:items='this.logs || []'></pager>
        <table class="table table-sm">
          <thead>
            <tr>
              <th>时间</th>
              <th>操作者</th>
              <th>内容</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="log in logs">
              <td>
                <local-time :time="log.created_at"></local-time>
              </td>
              <td>{{log.commander}}</td>
              <td>{{log.message}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Pager from './_partial/Pager'
import LocalTime from '@/components/_small/LocalTime'
import MaterialMixin from '@/mixins/material'
import LoadDataMixin from '@/mixins/load_data'

function updateMaterial () {
  const message = prompt('请输入备注')
  if (!message) {
    return
  }

  const data = {
    charge_on: this.material.charge_on,
    unit: this.material.unit,
    amount: this.material.amount,
    charge_amount: this.material.charge_amount,
    message: message
  }

  this.$http.put(`/api/materials/${this.material.mid}`, data).then(response => {
    this.loadData()
  })
}

function deleteMaterial () {
  const message = prompt(`您正在删除这个物料，操作不可撤回，请输入物料ID以继续`)
  if (message !== this.material.mid) {
    console.log(message)
    return
  }

  this.$http.delete(`/api/materials/${this.material.mid}`).then(response => {
    setTimeout(() => {
      this.$router.push('/materials')
    }, 3000)
  })
}

function loadData () {
  this.$http.get(`/api/materials/${this.$route.params.mid}`).then(response => {
    this.material = response.data.data
  })

  this.$http.get(`/api/materials/${this.$route.params.mid}/logs${location.search}`).then(response => {
    console.log(response.data.data)
    this.logs = response.data.data
  })
}

function deleteMaterialOn (productCode) {
  this.$http.post(`/api/materials/${this.$route.params.mid}/ons`, {
    action: 'delete',
    data: {
      'product_codes': [productCode]
    }
  }).then(response => {
    this.loadData()
  })
}

function addMaterialOn () {
  const productCode = prompt('请输入产品代码')
  if (!productCode) {
    return
  }

  this.$http.post(`/api/materials/${this.$route.params.mid}/ons`, {
    action: 'add',
    data: {
      product_codes: [productCode]
    }
  }).then(response => {
    this.loadData()
  })
}

export default {
  name: 'material',
  mixins: [MaterialMixin, LoadDataMixin],
  data () {
    return {
      material: null,
      logs: null
    }
  },
  methods: {
    loadData,
    updateMaterial,
    deleteMaterial,
    addMaterialOn,
    deleteMaterialOn
  },
  components: {
    Pager,
    LocalTime
  },
  mounted () {
    this.loadData()
  }
}
</script>s